var generateStyle = function generateStyle(componentTheme) {
  return {
    errors: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    error: {
      fontFamily: componentTheme.errorFontFamily,
      fontSize: componentTheme.errorFontSize,
      color: componentTheme.errorColor,
      flex: '1 1 auto'
    }
  };
};
export default generateStyle;